module.exports = __webpack_public_path__ + "a17d279f/img/revit-icon.5ff0d581.svg";